export const ForeverTimeValue = 4822948800
